// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  type MarketVarianceThresholdOverride,
  type MarketVarianceThresholdOverrideWireFormat,
  NewMarketVarianceThresholdOverride,
} from '../MarketVarianceThresholdOverride/MarketVarianceThresholdOverride';

export class UpdateVarianceThresholdSettingsRequest {
  readonly onTrackVarianceThreshold: string;
  readonly warningVarianceThreshold: string;
  readonly marketOverrides: MarketVarianceThresholdOverride[];

  constructor(data: { [key: string]: any } = {}) {
    this.onTrackVarianceThreshold =
      data.onTrackVarianceThreshold === undefined ? '0' : data.onTrackVarianceThreshold;
    this.warningVarianceThreshold =
      data.warningVarianceThreshold === undefined ? '0' : data.warningVarianceThreshold;
    this.marketOverrides = (data.marketOverrides ?? []).map((marketOverrides: any) =>
      NewMarketVarianceThresholdOverride(marketOverrides),
    );
  }

  static zero(): UpdateVarianceThresholdSettingsRequest {
    const zeroValues: ExcludeMethodsDeep<UpdateVarianceThresholdSettingsRequest> = {
      onTrackVarianceThreshold: '0',
      warningVarianceThreshold: '0',
      marketOverrides: [],
    };
    return new UpdateVarianceThresholdSettingsRequest(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type UpdateVarianceThresholdSettingsRequestWireFormat = {
  onTrackVarianceThreshold: string;
  warningVarianceThreshold: string;
  marketOverrides: MarketVarianceThresholdOverrideWireFormat[];
};

type NewUpdateVarianceThresholdSettingsRequestProps = PartialDeep<
  UpdateVarianceThresholdSettingsRequest,
  { recurseIntoArrays: true }
>;
export const NewUpdateVarianceThresholdSettingsRequest: (
  props: NewUpdateVarianceThresholdSettingsRequestProps,
) => UpdateVarianceThresholdSettingsRequest = (props) =>
  new UpdateVarianceThresholdSettingsRequest(props);

type NewUpdateVarianceThresholdSettingsRequestFromWireFormatProps = PartialDeep<
  UpdateVarianceThresholdSettingsRequestWireFormat,
  { recurseIntoArrays: true }
>;
export const NewUpdateVarianceThresholdSettingsRequestFromWireFormat: (
  props: NewUpdateVarianceThresholdSettingsRequestFromWireFormatProps,
) => UpdateVarianceThresholdSettingsRequest = (props) =>
  new UpdateVarianceThresholdSettingsRequest(props);
